import { VesselPositionDataExtended } from "../services/types/position-service.types";
import { VesselInfo } from "./types/vessels-model.types";

export abstract class DbModelBase extends EventTarget
{
  abstract populatePositionsTable(allVesselPositions: Map<number, VesselPositionDataExtended> ): Promise<void>;
  abstract getAllPositionsRecords(): Promise<VesselPositionDataExtended[]>;
  abstract populateVesselsTable(maerskVessels: Map<number, VesselInfo>, nonMaerskVessels: Map<number, VesselInfo>): Promise<void>;
  abstract getAllVesselsRecords(): Promise<VesselInfo[]>;
}

let DbModel: DbModelBase|null = null;

function setDbModel(model: DbModelBase)
{
  DbModel = model;
}

export { DbModel, setDbModel };